import { createFileRoute, redirect } from '@tanstack/react-router'
import { inRange } from 'lodash/fp'

import { skillsKeys } from '@/growth-map/queries/queryKeys'
import { skills } from '@/http/api/skills'

export const Route = createFileRoute('/skills-assessment/')({
  beforeLoad: async ({ context: { queryClient } }) => {
    const data = await queryClient.ensureQueryData({
      queryKey: skillsKeys.step(),
      queryFn: () => skills.assessmentStep(),
    })

    const isAssessmentSkipped =
      data?.num_completed_steps && inRange(1, 4, data.num_completed_steps)

    const redirectIndex = isAssessmentSkipped ? data.num_completed_steps + 1 : 0

    throw redirect({
      to: [
        '/skills-assessment/welcome',
        '/skills-assessment/poll-static',
        '/skills-assessment/results-initial',
        '/skills-assessment/poll-dynamic',
        '/skills-assessment/results-final',
      ][redirectIndex],
    })
  },
})
